import { render } from "./Item1.vue?vue&type=template&id=e7b434ca"
import script from "./Item1.vue?vue&type=script&lang=ts"
export * from "./Item1.vue?vue&type=script&lang=ts"
script.render = render

export default script